import Axios from 'axios'
import api from '@/services/api'

export default {
    namespaced: true,
    state: {
        // name: null,
        // phone: null,
        // gstin: null,
        // cid: null,
        // address: null,
        // _id: null,
        company: {},
        // hello: null
    },
    mutations: {
        SET_COMPANY (state, payload) {
            // state.name = payload.name,
            // state.phone = payload.phone,
            // state.gstin = payload.gstin,
            // state.cid = payload.gstin,
            // state.address = payload.address,
            // state._id = payload._id
            state.company=payload[0]
            state.company.code= payload[0].gstin.substring(0,2)
             //console.log(state.company )
        }
    },
    actions: {
        GET_COMPANY: async ({commit})  =>{
            let {data} = await Axios.get(api.baseUrl + 'company')
            commit('SET_COMPANY', data.data)
            //console.log(data.data)
        }
        
    }
}
